"use client";

import { useState } from "react";
import { Check, Link2 } from "lucide-react";
import { Button } from "@/components/ui/button";

/**
 * Konsistentes Teilen-Icon je Aktien-/Analyse-Seite (backlog.md -> Konsistenz/Politur-
 * Katalog, "Link kopieren, Vorschau via bestehendem opengraph-image.tsx") - `url` ist
 * bewusst eine volle absolute URL (nicht nur ein Pfad), da sowohl die native Web-Share-API
 * als auch `navigator.clipboard` eine vollstaendige, direkt teilbare Adresse brauchen. Die
 * "Vorschau" entsteht automatisch beim Einfuegen in Messenger/Social Media ueber die
 * bereits bestehende `opengraph-image.tsx`-Route der jeweiligen Seite, hier kein
 * zusaetzlicher Code noetig. Bewusst ein eigenstaendiger "Link teilen"-Button statt
 * Erweiterung von `ScoreCardExport` ("Score-Karte teilen") - das teilt ein generiertes
 * PNG-Bild, hier geht es um die Seiten-URL selbst, unterschiedliche Icons/Labels halten
 * beide auseinander.
 */
export function ShareButton({ url, title }: { url: string; title: string }) {
  const [copied, setCopied] = useState(false);

  async function handleShare() {
    if (typeof navigator !== "undefined" && navigator.share) {
      try {
        await navigator.share({ title, url });
      } catch {
        // Nutzer hat den nativen Share-Dialog abgebrochen (AbortError) oder er ist aus
        // einem anderen Grund fehlgeschlagen - kein Crash, einfach nichts weiter tun.
      }
      return;
    }
    try {
      await navigator.clipboard.writeText(url);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      // Clipboard-API kann in seltenen, nicht-sicheren Kontexten fehlschlagen - kein Crash.
    }
  }

  return (
    <Button type="button" variant="outline" size="sm" onClick={handleShare} className="gap-1.5">
      {copied ? <Check className="h-3.5 w-3.5" /> : <Link2 className="h-3.5 w-3.5" />}
      {copied ? "Link kopiert" : "Teilen"}
    </Button>
  );
}
